export const Messages = {
  availableVersion: 'Available version',
  tooltip: 'The date this version was published to the repository',
  whatsNew: "What's new",
};
